/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
const p = (a, c, s) => {
  const [o, t] = e.useState(a), r = e.useCallback(
    (n, l) => {
      t(n);
    },
    [s, t]
  );
  return [o, r];
};
export {
  p as useControlledState
};
